import React from "react";

import {useDispatch} from "react-redux";

import CircularProgress from "@material-ui/core/CircularProgress";
import SaveAltIcon from "@material-ui/icons/SaveAlt";

import {downloadPdf} from "../../../../../../../utils/utils";
import PrimaryButton from "../../../../../../../components/Buttons/PrimaryButton";
import {displayErrorSnackBar} from "../../../../../../../components/SnackbarProvider/actions";
import {getStepAnswer} from "../../../../../utils";


const ExAntePDFButton = ({dataService, btnText="Als PDF herunterladen"}) => {
  const [fileDownloadingProgress, setFileDownloadingProgress] = React.useState(false);
  const dispatch = useDispatch();

  const handlePdfDownload = () => {
    setFileDownloadingProgress(true);

    downloadPdf(`/reports/onboarding/ex-ante-pdf/`, undefined, 'POST', undefined, {
      customer_id: dataService.customer_id,
      onboarding_uid: dataService.onboarding_uid,
      ex_ante_data: {
        [dataService.uid]: dataService._questionnaire.steps.reduce((acc, step) => {
          const {step_uid, answers} = getStepAnswer(step);
          acc[step_uid] = answers;

          return acc;
        }, {})
      },
    })
    .then(() => setFileDownloadingProgress(false))
    .catch(() => {
      setFileDownloadingProgress(false)
      dispatch(displayErrorSnackBar("Das Ex-Ante-Gesamt-PDF konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut."))
    });
  };

  return (
    <PrimaryButton
      text={btnText}
      variant={"text"}
      disabled={fileDownloadingProgress}
      icon={fileDownloadingProgress ? <CircularProgress style={{color: 'rgba(0, 0, 0, 0.26)'}} size={15}/> : <SaveAltIcon />}
      onButtonClick={handlePdfDownload}
    />
  )
}

export default ExAntePDFButton;